import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback, useEffect } from 'react';

export function useHashNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll to hash on initial load or hash change
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location.hash, location.pathname]);

  const handleNavigation = useCallback((href: string, callback?: () => void) => {
    // Handle hash links (e.g., /#solutions, #about)
    if (href.includes('#')) {
      const [path, hash] = href.split('#');
      const targetPath = path || '/';
      const currentPath = location.pathname;

      if (currentPath === targetPath || (targetPath === '/' && currentPath === '/')) {
        // Same page, just scroll to the element
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        // Navigate to the page with hash
        navigate(`${targetPath}#${hash}`);
      }
    } else {
      // Regular navigation
      navigate(href);
    }
    
    callback?.();
  }, [navigate, location.pathname]);

  return { handleNavigation };
}
